export default __webpack_public_path__ + "static/media/illustration-algowork-w.044032e1.png";